var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20L1.40918 14.8646C0.540049 13.3617 0.0827842 11.6567 0.0833418 9.91004C0.0855692 4.44562 4.54102 0 10.0161 0C12.673 0.00129349 15.1667 1.03328 17.0423 2.90656C18.9173 4.77983 19.9498 7.26974 19.9488 9.91802C19.9464 15.3821 15.4902 19.8284 10.0161 19.8284C10.0157 19.8284 10.0165 19.8284 10.0161 19.8284H10.0118C8.34963 19.8278 6.71628 19.4116 5.26542 18.6219L0 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0186 1.67383C5.46478 1.67383 1.76144 5.36874 1.75977 9.91036C1.75909 11.4667 2.19547 12.9825 3.02182 14.2941L3.21827 14.6057L2.38406 17.6452L5.50869 16.8275L5.81041 17.006C7.07765 17.7566 8.53055 18.1536 10.0123 18.1543H10.0154C14.5657 18.1543 18.2691 14.459 18.2709 9.91704C18.2718 7.71605 17.4139 5.64633 15.8552 4.08944C14.2964 2.53255 12.2238 1.67476 10.0186 1.67383Z",
    fill: "url(#paint0_linear_4246_21875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53337 5.76675C7.34734 5.35436 7.15164 5.34601 6.97491 5.33877C6.83018 5.33264 6.66461 5.33301 6.49923 5.33301C6.33366 5.33301 6.06484 5.39503 5.83751 5.6429C5.61 5.89078 4.96875 6.48995 4.96875 7.70873C4.96875 8.9275 5.85816 10.1051 5.98206 10.2705C6.10614 10.4357 7.69894 13.0166 10.2217 14.0094C12.3181 14.8346 12.7447 14.6704 13.1999 14.6292C13.6549 14.588 14.6682 14.03 14.8749 13.4517C15.0818 12.8733 15.0818 12.3777 15.0198 12.2741C14.9577 12.1707 14.7923 12.1089 14.544 11.985C14.2958 11.8612 13.0756 11.2618 12.8481 11.1792C12.6206 11.0966 12.4552 11.0553 12.2896 11.3032C12.1242 11.5511 11.6489 12.1089 11.504 12.2741C11.3593 12.4395 11.2146 12.4602 10.9662 12.3363C10.718 12.2121 9.91866 11.9508 8.97046 11.107C8.23266 10.4504 7.73466 9.63956 7.58974 9.39169C7.44501 9.14381 7.5743 9.00975 7.69875 8.88628C7.81019 8.77524 7.94692 8.597 8.07119 8.45236C8.1949 8.30772 8.23638 8.20448 8.31898 8.03941C8.40177 7.87398 8.36047 7.72934 8.29833 7.60549C8.23638 7.48165 7.75401 6.25656 7.53337 5.76675Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4246_21875",
    x1: 9.84728,
    y1: 2.66284,
    x2: 9.9307,
    y2: 16.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsapp-logo.ab06bcf721e3959eaf08b9d58221f1c7.svg";
export { ForwardRef as ReactComponent };